import { createEmbedBlockPlainTextAdapterMatcher } from '@blocksuite/hive-block-embed';
import { BookmarkBlockSchema } from '@blocksuite/hive-model';
import { BlockPlainTextAdapterExtension } from '@blocksuite/hive-shared/adapters';

export const bookmarkBlockPlainTextAdapterMatcher =
  createEmbedBlockPlainTextAdapterMatcher(BookmarkBlockSchema.model.flavour);

export const BookmarkBlockPlainTextAdapterExtension =
  BlockPlainTextAdapterExtension(bookmarkBlockPlainTextAdapterMatcher);
